import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener, Inject
} from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { RouteInfo } from "./vertical-menu.metadata";
import { Subscription } from "rxjs";
import { NavbarContainerService } from "../services/navbar-container.service";
import { MenuDto } from "../modals/dashboard/menuDto";
import { DashboardInformationDto } from "../modals/dashboard/dashboardInformationDto";
import { LocalStorageService } from "../services/localstorage.service";
import { ConfigService } from "../services/config.service";
import { LayoutService } from "../services/layout.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations,
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('toggleIcon') toggleIcon!: ElementRef;
  menuItems!: MenuDto[]
  level: number = 0;
  logoUrl = 'assets/ContentTemplates/BrandLogo.png';
  logoFlag = false;
  public config: any = {};
  protected innerWidth: any;
  layoutSub!: Subscription;
  configSub!: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout: any;
  menuItemsDynamic!: MenuDto[];
  routeInfo!: RouteInfo
  DashboardInformationDto?: null | DashboardInformationDto;

  constructor(
    private navbarContainerServices: NavbarContainerService,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private localstorageService: LocalStorageService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }

  ngOnInit() {
    this.DashboardInfo();
    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
          this.logoFlag = this.collapseSidebar
        }
      });
    this.cdr.detectChanges()
  }

  DashboardInfo() {
    this.navbarContainerServices.GetDashboardInformation().subscribe(response => {
      this.DashboardInformationDto = response;
      this.localstorageService.setLocalData('SideBarMenulist', this.DashboardInformationDto?.menus)
      this.cdr.detectChanges()
    })
  }

  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
          this.logoFlag = this.collapseSidebar
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {
    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });


    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);

  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }
  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }
}
